// extracted by mini-css-extract-plugin
module.exports =  {"button":"_9cadcb71c3--button--Jwix_","button-left":"_9cadcb71c3--button-left--SjEfA","button-right":"_9cadcb71c3--button-right--FyK3I"};